import {TabContainer} from "base/ui/tab/components";
import {
    PermitExtensionDatesContent,
    PermitExtensionMaterialsContent,
    PermitExtensionTreesContent,
} from ".";
import {PermitExtensionForm} from "./form";

const PermitExtensionTypesAndDatesStep = ({entity, isStepEditable, onSubmit}) => {
    const tabs = [
        {
            label: "Guias",
            hash: "types",
            content: (
                <PermitExtensionForm entity={entity} onSubmit={onSubmit}>
                    <PermitExtensionDatesContent
                        entity={entity}
                        isStepEditable={isStepEditable}
                    />
                </PermitExtensionForm>
            ),
            disabled: false,
        },
        {
            label: "Árvores",
            hash: "trees",
            content: (
                <PermitExtensionTreesContent
                    extension={entity}
                    displayFees={false}
                    disabled={!isStepEditable}
                />
            ),
            disabled:
                !entity?.types?.includes("felling") &&
                !entity?.types?.includes("cutting"),
        },
        {
            label: "Materiais",
            hash: "materials",
            content: (
                <PermitExtensionMaterialsContent
                    extension={entity}
                    displayFees={false}
                    disabled={!isStepEditable}
                />
            ),
            disabled: !entity?.types?.includes("transport"),
        },
    ];

    return <TabContainer tabs={tabs} />;
};

export default PermitExtensionTypesAndDatesStep;
